import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Usuario } from 'src/app/models/usuario';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-nuevousuario',
  templateUrl: './nuevousuario.component.html',
  styleUrls: ['./nuevousuario.component.css']
})
export class NuevousuarioComponent implements OnInit {
  form: FormGroup;
  bactivapasswords = false;
  etiquetapassword = 'Cambiar Password';
  colorcambiante = '';
  seccion = '';
  idempresa = '';
  valorpagina = '';
  seccionsmx = true;


  constructor(
    public usuarioService: UsuarioService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<NuevousuarioComponent>,
    private formBuilder: FormBuilder,

    

  ) {
    this.idempresa = this.usuarioService.idempresa;
    this.buildForm();
    
  }

  ngOnInit() {
     this.valorpagina = localStorage.getItem('pagina');
     
    if (this.valorpagina === 'GESTOR') {
      this.seccion = 'USER_GESTOR';
      this.seccionsmx = false;
      // this.element = document.getElementById('rolusuario') as HTMLElement;
      // this.element
    }
  //  this.nuevoRegistro();
  }




 













  activapasswords() {

    if (this.bactivapasswords) {
      this.etiquetapassword = 'no cambiar password';
      this.bactivapasswords = false ;
    } else {
      this.bactivapasswords = true ;
    }
  }


  private buildForm() {
    this.form =  this.formBuilder.group({
      nombrecliente: ['', [Validators.required]],
      apellido: ['', [Validators.required]],
      dirigido:  [''],
      alias: ['', [Validators.required]],
      emailpersonal: ['', [Validators.required, Validators.email]],
      role: ['', [Validators.required]],
      activado: ['', [Validators.required]],
 _idusuario: [''], // este campo que e sla claave del registro se usara para saber si es edicion o agrega nuevo
      _idempresa: [this.idempresa],
      color:  [''],
      contrasena: null,
      contrasena2: null

    });
  }


  save(event: Event) {


    event.preventDefault();
    if (this.form.valid) {
       const value = this.form.value;


       const usuario = new Usuario(
         this.form.value.nombrecliente,
         this.form.value.apellido,
         this.form.value.emailpersonal,
         '',
         this.form.value.activado,
         this.form.value.contrasena,
         this.form.value._idempresa,
         
         false,
         this.form.value.role,
         this.form.value.color,
         this.form.value.alias,
      //   this.form.value._idusuario,
       );


       console.log (usuario);



       if  ((this.form.value._idusuario === null) || (this.form.value._idusuario === '')) {
        // alert ('agregar');

         this.usuarioService.altadeusuarios( usuario )
        .subscribe ( resp => {
          
          alert ('The new user has been successfully added');
          this.closeDialog();

        });

       } 


    } else {
      alert ('All fields are required');
      this.form.markAllAsTouched();
    }

     }

     closeDialog() {
     this.dialogRef.close();

     }



     sonIguales( campo1: string, campo2: string) {
      return (group: FormGroup) => {

        const pass1 = group.controls[campo1].value;
        const pass2 = group.controls[campo2].value;

        if ( pass1 === pass2 ) {
          return null;
        }

        return {
          sonIguales: true
        };
      };
    }


    nuevoRegistro() {
      this.form.reset();
     // this.bactivapasswords = true;

    }

    onChange(color) {
      alert (this.colorcambiante);
    }

}
